import { Box, Stack, Typography } from '@mui/material';
import { ReactComponent as CheckmarkIcon } from 'assets/icons/CheckmarkGrey.svg';
import { GuaranteesDialog } from 'common/components/GuaranteesDialog/GuaranteesDialog';
import { DialogComponentProps } from 'common/hooks/useDialog';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { styles } from './ProductCareGuaranteesDialog.styles';

export type ProductCareGuaranteesDialogProps = DialogComponentProps<void>;

export const ProductCareGuaranteesDialog: FC<ProductCareGuaranteesDialogProps> = ({
  instanceId,
  isOpen,
  onReject,
  onResolve,
}) => {
  const { t } = useTranslation();

  const contentItems = [
    {
      Icon: CheckmarkIcon,
      text: t('productCareDialog.content1.text'),
    },
    {
      Icon: CheckmarkIcon,
      text: t('productCareDialog.content2.text'),
    },
    {
      Icon: CheckmarkIcon,
      text: t('productCareDialog.content3.text'),
    },
  ];

  const content = (
    <Stack spacing={3}>
      {contentItems.map((item) => (
        <Stack key={item.text} direction="row" spacing={2}>
          <Box sx={styles.icon}>
            <item.Icon />
          </Box>
          <Box>
            <Typography color="textSecondary" variant="bodyM">
              {item.text}
            </Typography>
          </Box>
        </Stack>
      ))}
    </Stack>
  );

  return (
    <GuaranteesDialog
      content={content}
      instanceId={instanceId}
      isOpen={isOpen}
      onReject={onReject}
      onResolve={onResolve}
      title={t('productCareDialog.title')}
    />
  );
};
